"use client";

import { useEffect, useState } from "react";

/**
 * Ensures page content is rendered immediately on load for optimal FCP / LCP.
 */
export default function PageReadyGate({ children }) {
  const [ready, setReady] = useState(true);

  useEffect(() => {
    setReady(true);
  }, []);

  return children;
}
